// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:07:32.991Z
// Property: Tuscany at Faudree (ID: 6767906449167129)
// Collections: 36 amenities, 6 floorplans (live), 34 photos, 40 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167129",
  "property_external_id": "1089886",
  "property_zillow_url": "https://www.zillow.com/apartments/odessa-tx/tuscany-at-faudree/5XhxYm/",
  "property_apartments_url": "https://www.apartments.com/tuscany-at-faudree-odessa-tx/fdqh2zv/",
  "property_google_business_url": "https://www.google.com/maps/place/Tuscany+at+Faudree+Apartment+Homes/data=!4m2!3m1!1s0x0:0x6b14b1a0910b4025?sa=X&ved=2ahUKEwj8xbDszIOTAxVQSzABHSHpABcQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "55405269665",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tuscany-at-faudree",
  "property_name": "Tuscany at Faudree",
  "property_website_url": "https://www.tuscanyatfaudree.com",
  "property_domain": "https://www.tuscanyatfaudree.com",
  "property_address": "4001 Faudree Road",
  "property_full_address": "4001 Faudree Road, Odessa, TX, 79765",
  "property_address_1": "4001 Faudree Road",
  "property_address_2": null,
  "property_address_city": "Odessa",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79765",
  "property_address_country": "US",
  "property_address_county": "Ector County",
  "property_neighborhood_address": "Midland & Odessa",
  "property_address_latitude": "31.913",
  "property_address_longitude": "-102.2882",
  "property_email": "tuscany@weidner.com",
  "property_phone": "4322552819",
  "property_call_tracking_phone": "432-218-3299",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Tuscany in Odessa, TX, where luxury meets comfort in every detail. Choose from spacious one- and two-bedroom floor plans featuring sleek stainless steel appliances, built-in bookshelves, and serene courtyards. Enjoy exclusive amenities like a fitness center, spa, and pet-friendly spaces. Visit us—your new home awaits!",
  "property_long_description": "Welcome to Tuscany, where modern living meets comfort in the heart of Odessa, TX! Our stylish apartment community offers a variety of thoughtfully designed floor plans, featuring one and two-bedroom options that cater to your unique lifestyle. As you explore our homes, you’ll appreciate luxury finishes such as granite countertops, stainless steel appliances, and elegant crown molding, with select units boasting vaulted ceilings and cozy electric fireplaces.\n\nAt Tuscany, we prioritize your convenience and comfort with an array of top-notch amenities. Enjoy controlled access and the peace of mind that comes from having a dedicated property manager on-site. Our vibrant community features a full fitness center, refreshing pool, invigorating spa, and a luxurious resident lounge with a media center for movie nights. For outdoor enthusiasts, our beautiful courtyard and grill area provide the perfect setting to unwind.\n\nWe understand your furry friends are family too, which is why Tuscany is pet-friendly and equipped with pet stations throughout the community. Additional thoughtful amenities include high-speed internet access, in-home washer/dryers, and rentable outdoor storage, making Tuscany the ideal place to call home.\n\nDon’t miss out on our exclusive MISD & ECISD teacher's discount! Are you ready to elevate your living experience? Find your new home today by browsing our availability or scheduling a tour to visit our vibrant community at Tuscany!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0217-75c2-756d-aa63-c866125be8e4.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
    "public_id": "019d0217-75c2-756d-aa63-c866125be8e4",
    "storage_key": "property/6767906449167129/019d0217-75c2-756d-aa63-c866125be8e4.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2011",
  "property_year_renovated": null,
  "property_walk_score": "23",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.34146341463415",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "500-700",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome (no other pets). Maximum 2 pets per home. One‑time non‑refundable pet fee: $300 per pet. Refundable pet deposit: $300 per pet. Monthly pet rent: $25 per pet. Breed restrictions apply for dogs (e.g., Pit Bull, Rottweiler, German Shepherd, Great Dane, etc.).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://tuscanyatfaudree.securecafe.com/onlineleasing/tuscany-at-faudree/floorplans.aspx",
  "property_resident_portal_url": "https://tuscanyatfaudree.securecafe.com/residentservices/tuscany-at-faudree/userlogin.aspx",
  "property_apply_now_url": "https://tuscanyatfaudree.securecafe.com/onlineleasing/tuscany-at-faudree/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0217-80ce-754f-a421-ccf93b2ae952.webp",
  "property_primary_logo_media": {
    "alt_text": "Tuscany at Faudree Apartment Homes logo",
    "public_id": "019d0217-80ce-754f-a421-ccf93b2ae952",
    "storage_key": "property/6767906449167129/019d0217-80ce-754f-a421-ccf93b2ae952.webp",
    "width": 131,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0217-8f93-710a-957f-379a2f64f86f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Tuscany at Faudree Apartment Homes logo",
    "public_id": "019d0217-8f93-710a-957f-379a2f64f86f",
    "storage_key": "property/6767906449167129/019d0217-8f93-710a-957f-379a2f64f86f.webp",
    "width": 131,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0217-98c9-72ab-a921-b4b50a4a4a52.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Tuscany at Faudree Apartment Homes logo",
    "public_id": "019d0217-98c9-72ab-a921-b4b50a4a4a52",
    "storage_key": "property/6767906449167129/019d0217-98c9-72ab-a921-b4b50a4a4a52.webp",
    "width": 131,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#b96b30",
  "property_secondary_color": "#d6a055",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#9f4c3f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "762 - 1120",
  "property_sqft_min": "762",
  "property_sqft_max": "1120",
  "property_price_range": "1450 - 1785",
  "property_price_min": "1450",
  "property_price_max": "1785",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/TuscanyAtFaudreeApartments",
  "property_instagram_url": "https://www.instagram.com/faudreeranchapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX6QSsZnP-4YRJUALkaCxFGs",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Tuscany",
  "property_home_romance_title": "Embrace the Comfort of Your New Community Home Today",
  "property_home_amenities_blurb": "Welcome to Tuscany in Odessa, TX, where modern comfort meets thoughtful design. Our vibrant community features stylish one- and two-bedroom floor plans equipped with stainless steel appliances, in-home washers and dryers, and luxurious amenities like a sparkling pool, fitness center, and a cozy media lounge. Dive into the Tuscany lifestyle today!",
  "property_home_floorplans_blurb": "Welcome to Tuscany in Odessa, TX, where modern living meets irresistible comfort. Our thoughtfully designed floor plans cater to your unique lifestyle, offering space and style at every turn. Browse our available apartment homes and step into your ideal haven today—your perfect escape awaits at Tuscany!",
  "property_home_gallery_blurb": "Welcome to Tuscany in Odessa, TX, where luxurious living meets modern convenience. With stunning one and two-bedroom floor plans, indulge in spacious layouts featuring granite countertops and in-home washers/dryers. Enjoy amenities like a sparkling pool, fitness center, and lush courtyard. Picture yourself living here; your paradise awaits!",
  "property_home_neighborhood_blurb": "Welcome to Tuscany in Odessa, TX, where vibrant living meets excellent education. Choose from spacious one and two-bedroom floor plans nestled near top schools like L.B. Johnson Elementary and Permian High. Enjoy a community rich in academic opportunities, perfect for families seeking a nurturing environment. Uncover local favorites nearby!",
  "property_home_reviews_blurb": "At Tuscany in Odessa, TX, residents rave about the vibrant community spirit, stating, \"Living here feels like family.\" Experience a welcoming atmosphere where comfort meets style. Curious about life at Tuscany? See what our residents have to say about living at our community and find your perfect home today!",
  "property_neighborhood_blurb": "At Tuscany in Odessa, TX, your home is surrounded by exceptional educational institutions, including LB Johnson Elementary and Permian High School. Our vibrant community offers spacious one and two-bedroom floor plans, perfect for families. Dive into our neighborhood's rich tapestry of local schools and discover your ideal living environment!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Tuscany, where modern living meets comfort in Odessa, TX. Enjoy spacious one- and two-bedroom floor plans featuring upscale amenities like a sparkling pool, fitness center, and cozy lounge. With pet-friendly spaces, controlled access, and lush courtyards, your perfect home awaits. Dive into our vibrant community today! ",
  "property_applynow_blurb": "Welcome to Tuscany in Odessa, TX, where luxurious living meets convenience. Choose from spacious one and two-bedroom floor plans, featuring stylish granite countertops, in-home washers/dryers, and pet-friendly amenities. Enjoy our resort-style pool, fitness center, and the cozy resident lounge for unforgettable moments. Lease online today for the ultimate lifestyle!",
  "property_contactus_blurb": "At Tuscany in Odessa, TX, your dream apartment awaits! Choose from stylish one or two-bedroom floor plans, designed for modern living. Each space blends comfort and elegance, perfect for your lifestyle. Have questions? Contact our leasing team today and start your journey to the ideal home!",
  "property_faqs_blurb": "At Tuscany in Odessa, TX, our diverse floor plans include stylish one and two-bedroom apartments tailored to your lifestyle needs. Got questions about our vibrant community? Our FAQs page has you covered, offering insights to help you feel right at home. Start your journey to comfortable living today!",
  "property_floorplans_blurb": "At Tuscany in Odessa, TX, your ideal home awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to suit every lifestyle. Embrace comfort and style—explore our unique layouts that cater to your needs. Browse our available apartment homes and find your perfect fit today!",
  "property_gallery_blurb": "At Tuscany in Odessa, TX, vibrant living meets modern comfort. Choose from our thoughtfully designed one- and two-bedroom apartments, featuring stainless steel appliances, spacious patios, and relaxing courtyards. Enjoy premium amenities like a fitness center, media room, and pet-friendly spaces. Picture yourself living here—your oasis awaits!",
  "property_interactivemap_blurb": "At Tuscany in Odessa, TX, your perfect home awaits with spacious one and two-bedroom floor plans, stunning amenities, and modern features. Enjoy leisurely afternoons by the pool or host friends in our luxurious resident lounge. Use our interactive community map to find your ideal living space today!",
  "property_pets_blurb": "At Tuscany in Odessa, TX, your furry friends can thrive alongside you in our vibrant community. With stylish apartments and a pet-friendly atmosphere, you can enjoy life with your cat or dog—just remember to check our breed guidelines! Live comfortably, surrounded by options that accommodate both you and your pets.",
  "property_referafriend_blurb": "At Tuscany in Odessa, TX, we believe that great friends make the best neighbors! With spacious one and two-bedroom floor plans that fit every lifestyle, your perfect home awaits. Share the joy of living in our welcoming community—refer a friend today and double the happiness at Tuscany!",
  "property_residentaccess_blurb": "Welcome to Tuscany, where modern living meets comfort in Odessa, TX. Choose from spacious one and two-bedroom floor plans tailored to your lifestyle. Access your resident portal to pay rent, schedule maintenance, and enjoy seamless living. Your Tuscany experience starts here—effortless convenience at your fingertips!",
  "property_reviews_blurb": "At Tuscany in Odessa, TX, residents rave about the sense of community, stating, “The friendly atmosphere makes it feel like home.” Experience this warmth for yourself—delve into our property reviews and see what our residents have to say about living at our vibrant apartment community!",
  "property_created_at": "1771529002698",
  "property_scheduletour_blurb": "At Tuscany in Odessa, TX, we offer thoughtfully designed one- and two-bedroom apartments that reflect your lifestyle. Spacious layouts, modern amenities, and a vibrant community await you. Ready to see why our residents love calling Tuscany home? Schedule a tour today and hear their stories!",
  "property_thankyou_blurb": "Thank you for reaching out to Tuscany in Odessa, TX! We offer stunning one and two-bedroom floor plans designed for comfort and style. A member of our team will be in touch soon to help you find your perfect home in our vibrant community. Stay tuned for more exciting details!",
  "property_virtualtours_blurb": "Experience the charm of Tuscany in Odessa, TX, where our thoughtfully designed one and two-bedroom apartments await. Each layout invites comfort and style, tailored to your lifestyle. Ready to find your new home? Take a virtual tour today and envision life in our vibrant community!",
  "property_copyright": "2026 All Rights Reserved. Tuscany",
  "property_seo_title_home": "Tuscany |  Apartments in Odessa, TX",
  "property_seo_description_home": "Experience luxury living at Tuscany in Odessa, TX. With stunning amenities and stylish apartments, your dream home awaits. Join our community today!",
  "property_seo_title_floorplans": "Floor Plans | Odessa, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Tuscany in Odessa, TX! Browse unique one and two-bedroom floor plans designed for comfort and style. Your perfect space awaits!",
  "property_seo_title_amenities": "Amenities | Odessa, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Tuscany in Odessa, TX! Enjoy a pet-friendly community with a pool, fitness center, and stylish apartments with granite countertops.",
  "property_seo_title_gallery": "Gallery | Apartments in Odessa, TX",
  "property_seo_description_gallery": "Experience Tuscany in Odessa, TX! Embrace stylish living with modern amenities, spacious floor plans, and a vibrant community. Picture your new life today!",
  "property_seo_title_virtualtours": "Virtual Tours | Tuscany Apartments",
  "property_seo_description_virtualtours": "Experience Tuscany in Odessa, TX! Take a virtual tour of our inviting one- and two-bedroom apartments, where comfort meets style. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Tuscany Apartments",
  "property_seo_description_interactivemap": "Find your ideal apartment at Tuscany in Odessa, TX! Use our interactive map to explore floor plans, amenities, and discover the perfect space for you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Odessa, TX",
  "property_seo_description_neighborhood": "Uncover the charm of Tuscany in Odessa, TX! Dive into local favorites and hotspots just steps from your door. Your vibrant lifestyle awaits!",
  "property_seo_title_contact": "Contact Us | Tuscany",
  "property_seo_description_contact": "Unit your dreams at Tuscany in Odessa, TX! Choose from stylish one and two-bedroom floor plans. Questions? Reach out to our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Odessa, TX",
  "property_seo_description_faqs": "Find answers to your questions about Tuscany in Odessa, TX. From amenities to floor plans, our FAQs cover everything you need for a comfortable lifestyle!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Odessa, TX",
  "property_seo_description_reviews": "Discover Tuscany in Odessa, TX! Hear resident reviews about our vibrant community, stylish apartments, and stunning amenities. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Odessa, TX",
  "property_seo_description_applynow": "Experience luxury living at Tuscany in Odessa, TX—where modern comforts meet resort-style amenities. Your new home awaits! Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Tuscany",
  "property_seo_description_residentaccess": "Elevate your living experience at Tuscany in Odessa, TX. Log in now for easy rent payments, maintenance requests, and community updates—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Tuscany",
  "property_seo_description_referafriend": "Invite your friends to join the Tuscany community in Odessa, TX! Enjoy fantastic amenities together and create lasting memories. Refer a friend today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Tuscany",
  "property_seo_description_scheduletour": "Experience the charm of Tuscany in Odessa, TX. Schedule your tour today and envision your next home in our vibrant community filled with luxurious amenities.",
  "property_seo_title_privacy": "Privacy Policy | Tuscany",
  "property_seo_description_privacy": "At Tuscany in Odessa, TX, your privacy is priority. Explore our policy for secure living and enjoy peace of mind in our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Tuscany",
  "property_seo_description_accessibility": "Discover seamless living at Tuscany in Odessa, TX, where digital inclusion ensures all residents enjoy accessible amenities—connect today!",
  "property_seo_title_sitemap": "Sitemap | Tuscany",
  "property_seo_description_sitemap": "Navigate your way through Tuscany in Odessa, TX! Our sitemap makes it easy to find everything you need to elevate your living experience.",
  "property_seo_title_thankyou": "Thank You | Tuscany",
  "property_seo_description_thankyou": "Thank you for reaching out to Tuscany in Odessa, TX! Our team will connect soon to help you find your perfect home in our charming community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Odessa, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293661173",
  "amenities": [
    {
      "id": "ec_90f4d35c3a18813a3cf3e354",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352978",
      "title": "Year-Round Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d9a42-8385-75fd-8924-bd3ec1aed241.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019d9a42-8385-75fd-8924-bd3ec1aed241",
        "storage_key": "property/6767906449167129/019d9a42-8385-75fd-8924-bd3ec1aed241.webp",
        "width": 1024,
        "height": 680
      },
      "amenity_image_alt_text": "Tuscany at Faudree Resort Style Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ca00f9237cd07ffe879cb2e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352976",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-6d7b-7518-9eed-43b08352d933.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills and elliptical machines",
        "public_id": "019d0214-6d7b-7518-9eed-43b08352d933",
        "storage_key": "property/6767906449167129/019d0214-6d7b-7518-9eed-43b08352d933.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Tuscany at Faudree Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e53cc9bc27d21292f9571a50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352977",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec9b7142999a1cd16d14489e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400113",
      "title": "Media Center with Movies and Popcorn",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-75c3-747d-a8ba-e06ec62cefd0.webp",
      "amenity_image_media": {
        "alt_text": "Lobby lounge area with plush leather armchairs and a coffee table.",
        "public_id": "019d0214-75c3-747d-a8ba-e06ec62cefd0",
        "storage_key": "property/6767906449167129/019d0214-75c3-747d-a8ba-e06ec62cefd0.webp",
        "width": 1019,
        "height": 680
      },
      "amenity_image_alt_text": "Tuscany at Faudree Media Center with Movies and Popcorn",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90ee964a17961901cd495a82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352974",
      "title": "Propane Gas Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-a045-700b-b02f-4c0395fd99d1.webp",
      "amenity_image_media": {
        "alt_text": "Built-in outdoor grill with granite countertop in a grassy area with trees and a palm tree.",
        "public_id": "019d0214-a045-700b-b02f-4c0395fd99d1",
        "storage_key": "property/6767906449167129/019d0214-a045-700b-b02f-4c0395fd99d1.webp",
        "width": 1026,
        "height": 684
      },
      "amenity_image_alt_text": "Tuscany at Faudree Grilling Station",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35fb731a9e2d958f28cc4154",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400198",
      "title": "Attached Garage Included with 3 Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d9a42-83dc-71c0-bbdd-89f780586e08.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with a row of garages.",
        "public_id": "019d9a42-83dc-71c0-bbdd-89f780586e08",
        "storage_key": "property/6767906449167129/019d9a42-83dc-71c0-bbdd-89f780586e08.webp",
        "width": 1024,
        "height": 681
      },
      "amenity_image_alt_text": "Tuscany at Faudree Garage",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_230d2cb7a10c71f0edc66c62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400194",
      "title": "Carport & Garage Parking Available for Rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ed40b6ea7b0819418511d0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352973",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-ac46-70e8-8f01-37b3129ec074.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment building with orange facade, balconies, and green lawn.",
        "public_id": "019d0214-ac46-70e8-8f01-37b3129ec074",
        "storage_key": "property/6767906449167129/019d0214-ac46-70e8-8f01-37b3129ec074.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Tuscany at Faudree Courtyard and Green Space",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93d1138d5c6f5e862ee0b934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352979",
      "title": "Year-Round Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-8adb-7102-93f4-74b0d2b45afa.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d0214-8adb-7102-93f4-74b0d2b45afa",
        "storage_key": "property/6767906449167129/019d0214-8adb-7102-93f4-74b0d2b45afa.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Tuscany at Faudree Spa and Hot Tub",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_626580819285ae9f5a7792f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352982",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99f888fbe8440e475c32fa6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352983",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_268b4680e9442d4221e2378a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352980",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1223ef40bc233fd7fbf197e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352972",
      "title": "Luxurious Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-74ba-7479-aa62-477d35576a1d.webp",
      "amenity_image_media": {
        "alt_text": "Luxury lounge area with fireplace and plush seating.",
        "public_id": "019d0214-74ba-7479-aa62-477d35576a1d",
        "storage_key": "property/6767906449167129/019d0214-74ba-7479-aa62-477d35576a1d.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6774c89cc84ebc66345a4a12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352970",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b1a4db8ee55a68a71bc32a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352975",
      "title": "Love Note Community Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_749e6fc5727a52d2af36d0d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "88164626",
      "title": "MISD & ECISD Teacher's Discount",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-cdce-7121-afba-730ad2c13cfc.webp",
      "amenity_image_media": {
        "alt_text": "MISD and ECISD Teacher's Discount graphic",
        "public_id": "019d0214-cdce-7121-afba-730ad2c13cfc",
        "storage_key": "property/6767906449167129/019d0214-cdce-7121-afba-730ad2c13cfc.webp",
        "width": 2919,
        "height": 1712
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d15f3b84c63c94a3ac816d6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400195",
      "title": "Rentable Outdoor Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da83d542bb64d42c95105d57",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400196",
      "title": "Pet Friendly with Pet Stations Throughout",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_199e1ef9d7735bd75695df20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "124799878",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7baa4f2c237eb0bf47764fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352991",
      "title": "Electric Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-3ef3-7691-a16b-223e8da9147c.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, sofa, and decorative mirrors.",
        "public_id": "019d0214-3ef3-7691-a16b-223e8da9147c",
        "storage_key": "property/6767906449167129/019d0214-3ef3-7691-a16b-223e8da9147c.webp",
        "width": 1023,
        "height": 682
      },
      "amenity_image_alt_text": "Tuscany at Faudree Living Room with Electric Fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0b1cad073ae4c4fb0a9f478",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400286",
      "title": "In-Home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-64e1-73cc-95b0-25e19607ddce.webp",
      "amenity_image_media": {
        "alt_text": "Hallway with washer, dryer, and access to bathroom.",
        "public_id": "019d0214-64e1-73cc-95b0-25e19607ddce",
        "storage_key": "property/6767906449167129/019d0214-64e1-73cc-95b0-25e19607ddce.webp",
        "width": 1023,
        "height": 682
      },
      "amenity_image_alt_text": "Tuscany at Faudree In-Unit Washer and Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40816e2f8cd35595ef6c8540",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352992",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-7fdb-762a-a130-0ea683e6d870.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating area overlooking palm trees and apartment buildings.",
        "public_id": "019d0214-7fdb-762a-a130-0ea683e6d870",
        "storage_key": "property/6767906449167129/019d0214-7fdb-762a-a130-0ea683e6d870.webp",
        "width": 1024,
        "height": 681
      },
      "amenity_image_alt_text": "Tuscany at Faudree Large Balcony",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc8c2c7994d6702e0266af35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352993",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a15dbf61003608f6e7507d98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400285",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40f1456b9b4ad9c8cd168cf7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400283",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb397510ed6f07ab238ba5f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352990",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d9a42-8f2f-707e-ac33-860c5563fb49.webp",
      "amenity_image_media": {
        "alt_text": "Living room with purple chaise, dining area, and large windows.",
        "public_id": "019d9a42-8f2f-707e-ac33-860c5563fb49",
        "storage_key": "property/6767906449167129/019d9a42-8f2f-707e-ac33-860c5563fb49.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1fd51c929460c7e6c029dfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352988",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5806b78fcfd0878f479f1f7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352999",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7922f186026a16e44e0e0865",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87400281",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d3ffd88ba64cd2329f1cb20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352986",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-cc8d-75ef-8649-08359df916c5.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "019d0214-cc8d-75ef-8649-08359df916c5",
        "storage_key": "property/6767906449167129/019d0214-cc8d-75ef-8649-08359df916c5.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "Tuscany at Faudree Stainless Steel Appliances",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f93f61d9e001e7b3076c644",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "89344237",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04bfb2adce5a0bd8e5b9eb5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87353001",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-cc8c-722b-bd56-b10cc628de13.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a large framed mirror and a closet",
        "public_id": "019d0214-cc8c-722b-bd56-b10cc628de13",
        "storage_key": "property/6767906449167129/019d0214-cc8c-722b-bd56-b10cc628de13.webp",
        "width": 1024,
        "height": 682
      },
      "amenity_image_alt_text": "Tuscany at Faudree Large Bedroom with Walk In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73ba3622f9b16b982a930fac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352996",
      "title": "Built-In Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-4c8a-7448-a077-517f76b0d695.webp",
      "amenity_image_media": {
        "alt_text": "Built-in shelving and desk area with decorative items.",
        "public_id": "019d0214-4c8a-7448-a077-517f76b0d695",
        "storage_key": "property/6767906449167129/019d0214-4c8a-7448-a077-517f76b0d695.webp",
        "width": 1024,
        "height": 681
      },
      "amenity_image_alt_text": "Tuscany at Faudree Built in Shelving and Desk",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2847f09ef5cdc5dd202d5b5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352997",
      "title": "Built-In Office/Desk in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a107d88d52f1390e8a3420a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352985",
      "title": "Granite Countertop Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-d3a2-72be-b550-6bc26c1ab408.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel sink, granite countertops, and dining area with view.",
        "public_id": "019d0214-d3a2-72be-b550-6bc26c1ab408",
        "storage_key": "property/6767906449167129/019d0214-d3a2-72be-b550-6bc26c1ab408.webp",
        "width": 1021,
        "height": 681
      },
      "amenity_image_alt_text": "Tuscany at Faudree Granite Countertop Breakfast Bar",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b633dc584af02d57545db9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "external_id": "87352998",
      "title": "Dining Area",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-4a09-749f-be2b-ed59d72a6bb8.webp",
      "amenity_image_media": {
        "alt_text": "Dining area with glass-top table and two chairs, large windows with blinds overlooking palm trees.",
        "public_id": "019d0214-4a09-749f-be2b-ed59d72a6bb8",
        "storage_key": "property/6767906449167129/019d0214-4a09-749f-be2b-ed59d72a6bb8.webp",
        "width": 1024,
        "height": 681
      },
      "amenity_image_alt_text": "Tuscany at Faudree Dining Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e2dd6f1bae430c3e5218e841",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-3f07-773e-8a54-76e12649bf68.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, armchair, coffee table, and bar seating.",
        "public_id": "019d0214-3f07-773e-8a54-76e12649bf68",
        "storage_key": "property/6767906449167129/019d0214-3f07-773e-8a54-76e12649bf68.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring comfortable seating, a breakfast bar with stools, and large windows with blinds.",
      "link": "false",
      "alt_text": "Living room and dining area with a sofa, armchair, coffee table, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (1).jpg"
    },
    {
      "id": "ec_89ae3990a9208240de7866f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-3ef3-7691-a16b-223e8da9147c.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, and decorative mirrors.",
        "public_id": "019d0214-3ef3-7691-a16b-223e8da9147c",
        "storage_key": "property/6767906449167129/019d0214-3ef3-7691-a16b-223e8da9147c.webp",
        "width": 1023,
        "height": 682
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, decorative mirrors, and a stylish armchair, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with a fireplace, sofa, and decorative mirrors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (2).jpg"
    },
    {
      "id": "ec_22ec30826375cc0bbeabc29a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-3f07-773e-8a54-726b95cef265.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets and stainless steel appliances, open to a living area.",
        "public_id": "019d0214-3f07-773e-8a54-726b95cef265",
        "storage_key": "property/6767906449167129/019d0214-3f07-773e-8a54-726b95cef265.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring dark wood cabinetry, granite countertops, and stainless steel appliances. Enjoy an open-concept living space perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets and stainless steel appliances, open to a living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (3).jpg"
    },
    {
      "id": "ec_dc505be829cf614bf14e8acd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-49ff-772f-9f7a-86693d747cac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and pendant lighting.",
        "public_id": "019d0214-49ff-772f-9f7a-86693d747cac",
        "storage_key": "property/6767906449167129/019d0214-49ff-772f-9f7a-86693d747cac.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience culinary delight in this beautifully appointed kitchen, featuring rich dark wood cabinetry, elegant granite countertops, and a full suite of modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and pendant lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (4).jpg"
    },
    {
      "id": "ec_50f23beac076ec449f7f77ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-4a09-749f-be2b-ed59d72a6bb8.webp",
      "image_media": {
        "alt_text": "Dining area with glass-top table and two chairs, large windows with blinds overlooking palm trees.",
        "public_id": "019d0214-4a09-749f-be2b-ed59d72a6bb8",
        "storage_key": "property/6767906449167129/019d0214-4a09-749f-be2b-ed59d72a6bb8.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, perfect for intimate gatherings. Large windows offer scenic views of the surrounding landscape.",
      "link": "false",
      "alt_text": "Dining area with glass-top table and two chairs, large windows with blinds overlooking palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (5).jpg"
    },
    {
      "id": "ec_ced47a535cf85083b3f91c71",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-4a2f-7005-8f57-15515ade6a54.webp",
      "image_media": {
        "alt_text": "Home office with glass desk, office chair, and window.",
        "public_id": "019d0214-4a2f-7005-8f57-15515ade6a54",
        "storage_key": "property/6767906449167129/019d0214-4a2f-7005-8f57-15515ade6a54.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this stylish home office, featuring a glass-top desk and comfortable seating. A large window fills the space with natural light.",
      "link": "false",
      "alt_text": "Home office with glass desk, office chair, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (6).jpg"
    },
    {
      "id": "ec_7de8a71803ae67f81fd5ab92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-4c8a-7448-a077-517f76b0d695.webp",
      "image_media": {
        "alt_text": "Built-in shelving and desk area with decorative items.",
        "public_id": "019d0214-4c8a-7448-a077-517f76b0d695",
        "storage_key": "property/6767906449167129/019d0214-4c8a-7448-a077-517f76b0d695.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Apartment",
      "description": "Enjoy ample storage and display space with elegant built-in shelving and a convenient desk area, perfect for personalizing your apartment.",
      "link": "false",
      "alt_text": "Built-in shelving and desk area with decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (7).jpg"
    },
    {
      "id": "ec_f6242ef1f70917c9d89679ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-5548-75f7-aa7b-465e00f09243.webp",
      "image_media": {
        "alt_text": "Interior view of a multifamily apartment, showing a hallway leading to a bathroom and living area.",
        "public_id": "019d0214-5548-75f7-aa7b-465e00f09243",
        "storage_key": "property/6767906449167129/019d0214-5548-75f7-aa7b-465e00f09243.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience the spacious and inviting interiors of our apartments. This view showcases a well-appointed living area and a glimpse into the private bathroom, offering comfort and convenience.",
      "link": "false",
      "alt_text": "Interior view of a multifamily apartment, showing a hallway leading to a bathroom and living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (8).jpg"
    },
    {
      "id": "ec_659c982e2249d810b7dfaf9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-56fa-750f-8cd5-536c99427028.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-sized bed, two nightstands, a ceiling fan, and an en-suite bathroom.",
        "public_id": "019d0214-56fa-750f-8cd5-536c99427028",
        "storage_key": "property/6767906449167129/019d0214-56fa-750f-8cd5-536c99427028.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedrooms, featuring plush bedding, elegant decor, and convenient en-suite bathrooms. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Primary bedroom with a queen-sized bed, two nightstands, a ceiling fan, and an en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (9).jpg"
    },
    {
      "id": "ec_3b63b900cf81dae987066ec6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-56f5-717f-9e01-bcf448e2a197.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, large mirror, tub, and toilet.",
        "public_id": "019d0214-56f5-717f-9e01-bcf448e2a197",
        "storage_key": "property/6767906449167129/019d0214-56f5-717f-9e01-bcf448e2a197.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Apartment",
      "description": "Enjoy this spacious bathroom featuring a double vanity with ample counter space, a soaking tub with shower, and a private toilet area.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks, large mirror, tub, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (10).jpg"
    },
    {
      "id": "ec_0e0cdfef22cfda314178bd23",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-610a-7052-a90a-2e07b05ce157.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, a ceiling fan, and a window with blinds.",
        "public_id": "019d0214-610a-7052-a90a-2e07b05ce157",
        "storage_key": "property/6767906449167129/019d0214-610a-7052-a90a-2e07b05ce157.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Featuring a plush queen-sized bed, elegant nightstands with lamps, and a ceiling fan for your comfort. The large window with blinds allows for natural light and privacy.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, nightstands, a ceiling fan, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (11).jpg"
    },
    {
      "id": "ec_74e88fe699695f6fc05da185",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-62b1-779a-9bb3-f63a1fef2474.webp",
      "image_media": {
        "alt_text": "Home office with a glass desk, ergonomic chair, and comfortable armchair.",
        "public_id": "019d0214-62b1-779a-9bb3-f63a1fef2474",
        "storage_key": "property/6767906449167129/019d0214-62b1-779a-9bb3-f63a1fef2474.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this stylish home office, complete with a modern glass desk and a cozy armchair.",
      "link": "false",
      "alt_text": "Home office with a glass desk, ergonomic chair, and comfortable armchair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (12).jpg"
    },
    {
      "id": "ec_6a5a629edc63422e776ab567",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-64e1-73cc-95b0-25e19607ddce.webp",
      "image_media": {
        "alt_text": "Hallway with washer, dryer, and access to bathroom.",
        "public_id": "019d0214-64e1-73cc-95b0-25e19607ddce",
        "storage_key": "property/6767906449167129/019d0214-64e1-73cc-95b0-25e19607ddce.webp",
        "width": 1023,
        "height": 682
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area featuring a washer and dryer, with easy access to a full bathroom.",
      "link": "false",
      "alt_text": "Hallway with washer, dryer, and access to bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (13).jpg"
    },
    {
      "id": "ec_720610500992863420730c76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-664f-7259-ae99-fd6fa499689f.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight rack, and exercise balls.",
        "public_id": "019d0214-664f-7259-ae99-fd6fa499689f",
        "storage_key": "property/6767906449167129/019d0214-664f-7259-ae99-fd6fa499689f.webp",
        "width": 1023,
        "height": 682
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, and a comprehensive weight rack for all your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight rack, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (14).jpg"
    },
    {
      "id": "ec_182b723634c83cf704eabc41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-6d7b-7518-9eed-43b08352d933.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and elliptical machines",
        "public_id": "019d0214-6d7b-7518-9eed-43b08352d933",
        "storage_key": "property/6767906449167129/019d0214-6d7b-7518-9eed-43b08352d933.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines and open space for workouts.",
      "link": "false",
      "alt_text": "Gym with treadmills and elliptical machines",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (15).jpg"
    },
    {
      "id": "ec_7d1bbce58091c1f0dbd717af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-74ba-7479-aa62-477d35576a1d.webp",
      "image_media": {
        "alt_text": "Luxury lounge area with fireplace and plush seating.",
        "public_id": "019d0214-74ba-7479-aa62-477d35576a1d",
        "storage_key": "property/6767906449167129/019d0214-74ba-7479-aa62-477d35576a1d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our elegantly appointed community lounge, featuring a cozy fireplace and sophisticated seating arrangements.",
      "link": "false",
      "alt_text": "Luxury lounge area with fireplace and plush seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (16).jpg"
    },
    {
      "id": "ec_94a773edcbd4284b9d2f34cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-75c3-747d-a8ba-e06ec62cefd0.webp",
      "image_media": {
        "alt_text": "Lobby lounge area with plush leather armchairs and a coffee table.",
        "public_id": "019d0214-75c3-747d-a8ba-e06ec62cefd0",
        "storage_key": "property/6767906449167129/019d0214-75c3-747d-a8ba-e06ec62cefd0.webp",
        "width": 1019,
        "height": 680
      },
      "title": "Community",
      "description": "Relax in the comfortable lobby lounge, featuring plush leather seating and a large screen TV, perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "Lobby lounge area with plush leather armchairs and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (17).jpg"
    },
    {
      "id": "ec_64d1bdbb55793aa7ab2c43bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-7e49-700d-81ac-ad808f1cf1e1.webp",
      "image_media": {
        "alt_text": "Elegant clubhouse lounge with fireplace and large windows overlooking trees.",
        "public_id": "019d0214-7e49-700d-81ac-ad808f1cf1e1",
        "storage_key": "property/6767906449167129/019d0214-7e49-700d-81ac-ad808f1cf1e1.webp",
        "width": 1049,
        "height": 692
      },
      "title": "Community",
      "description": "Relax in the beautifully appointed clubhouse lounge, featuring a cozy fireplace and abundant natural light. A perfect space for residents to gather and unwind.",
      "link": "false",
      "alt_text": "Elegant clubhouse lounge with fireplace and large windows overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (18).jpg"
    },
    {
      "id": "ec_a2b2af0fa2f6508f3fe645e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-7f4f-778e-9f6d-fa3be22b87dc.webp",
      "image_media": {
        "alt_text": "Reception desk and seating area with a view of a lounge with fireplace.",
        "public_id": "019d0214-7f4f-778e-9f6d-fa3be22b87dc",
        "storage_key": "property/6767906449167129/019d0214-7f4f-778e-9f6d-fa3be22b87dc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome guests in our elegant reception area, featuring a well-appointed desk and comfortable seating, with a glimpse into our cozy lounge.",
      "link": "false",
      "alt_text": "Reception desk and seating area with a view of a lounge with fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (19).jpg"
    },
    {
      "id": "ec_e5951f2f9f181d4ba74200ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-7fdb-762a-a130-0ea683e6d870.webp",
      "image_media": {
        "alt_text": "Balcony with seating area overlooking palm trees and apartment buildings.",
        "public_id": "019d0214-7fdb-762a-a130-0ea683e6d870",
        "storage_key": "property/6767906449167129/019d0214-7fdb-762a-a130-0ea683e6d870.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony, complete with comfortable seating and a scenic view of the lush palm trees and surrounding community.",
      "link": "false",
      "alt_text": "Balcony with seating area overlooking palm trees and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (20).jpg"
    },
    {
      "id": "ec_cb96598bd6725fa6002d2e3a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-83c3-72f9-a9f9-3f4d6cfe91ba.webp",
      "image_media": {
        "alt_text": "Popcorn machine and kitchen counter with flowers in a multifamily property amenity area.",
        "public_id": "019d0214-83c3-72f9-a9f9-3f4d6cfe91ba",
        "storage_key": "property/6767906449167129/019d0214-83c3-72f9-a9f9-3f4d6cfe91ba.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy fresh popcorn from the community popcorn machine in this stylish amenity space, perfect for gatherings.",
      "link": "false",
      "alt_text": "Popcorn machine and kitchen counter with flowers in a multifamily property amenity area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (21).jpg"
    },
    {
      "id": "ec_f5dc317c85ce981b262d7339",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-8917-75bd-9c99-c59d83da66c9.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex swimming pool and lounge area with palm trees and waterfall feature.",
        "public_id": "019d0214-8917-75bd-9c99-c59d83da66c9",
        "storage_key": "property/6767906449167129/019d0214-8917-75bd-9c99-c59d83da66c9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, featuring a serene waterfall and plush lounge seating, set against a backdrop of lush palm trees and modern apartment buildings.",
      "link": "false",
      "alt_text": "Luxury apartment complex swimming pool and lounge area with palm trees and waterfall feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (22).jpg"
    },
    {
      "id": "ec_aaf830e73aa4605208415f76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-8adb-7102-93f4-74b0d2b45afa.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d0214-8adb-7102-93f4-74b0d2b45afa",
        "storage_key": "property/6767906449167129/019d0214-8adb-7102-93f4-74b0d2b45afa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and refreshing umbrellas.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (23).jpg"
    },
    {
      "id": "ec_69c1caa74fe8e2af8d162b08",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-8b12-748c-b657-58ba04f0537b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019d0214-8b12-748c-b657-58ba04f0537b",
        "storage_key": "property/6767906449167129/019d0214-8b12-748c-b657-58ba04f0537b.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs and lush palm trees.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (24).jpg"
    },
    {
      "id": "ec_f94bbcce2d72c4b6547e748a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-9525-7550-a35e-300601b0f4ac.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a waterfall feature and palm trees.",
        "public_id": "019d0214-9525-7550-a35e-300601b0f4ac",
        "storage_key": "property/6767906449167129/019d0214-9525-7550-a35e-300601b0f4ac.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with a cascading waterfall and lush palm trees. Enjoy a refreshing dip or lounge in the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with a waterfall feature and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (25).jpg"
    },
    {
      "id": "ec_92dafb8bbc64b83786c9b8ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-9aee-7288-9be5-7e217160ffe7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings.",
        "public_id": "019d0214-9aee-7288-9be5-7e217160ffe7",
        "storage_key": "property/6767906449167129/019d0214-9aee-7288-9be5-7e217160ffe7.webp",
        "width": 1021,
        "height": 679
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas perfect for relaxing on sunny days.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by palm trees and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (26).jpg"
    },
    {
      "id": "ec_9ef88c073e2201363f0df467",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-a045-700b-b02f-4c0395fd99d1.webp",
      "image_media": {
        "alt_text": "Built-in outdoor grill with granite countertop in a grassy area with trees and a palm tree.",
        "public_id": "019d0214-a045-700b-b02f-4c0395fd99d1",
        "storage_key": "property/6767906449167129/019d0214-a045-700b-b02f-4c0395fd99d1.webp",
        "width": 1026,
        "height": 684
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with this built-in grill, perfect for gathering with friends and family. Located in a lush, green courtyard setting.",
      "link": "false",
      "alt_text": "Built-in outdoor grill with granite countertop in a grassy area with trees and a palm tree.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (27).jpg"
    },
    {
      "id": "ec_f93698eebb0523892c61bb96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-a124-722a-9c44-2b57689f5c32.webp",
      "image_media": {
        "alt_text": "Outdoor gas grill station with a pool and seating area in the background.",
        "public_id": "019d0214-a124-722a-9c44-2b57689f5c32",
        "storage_key": "property/6767906449167129/019d0214-a124-722a-9c44-2b57689f5c32.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining at our community's barbecue area, complete with a grill, seating, and a nearby pool for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor gas grill station with a pool and seating area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (28).jpg"
    },
    {
      "id": "ec_894ee0cd939d652656d2b54b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-a11a-748a-a0b2-764162648cf6.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment complex featuring buildings and a row of garages under a blue sky.",
        "public_id": "019d0214-a11a-748a-a0b2-764162648cf6",
        "storage_key": "property/6767906449167129/019d0214-a11a-748a-a0b2-764162648cf6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex showcasing its buildings and a row of garages, set against a backdrop of a bright blue sky with scattered clouds.",
      "link": "false",
      "alt_text": "Exterior view of the apartment complex featuring buildings and a row of garages under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (29).jpg"
    },
    {
      "id": "ec_75c2936c767c3f733da4e2c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-a6bb-7668-8cd6-91de8bc51c18.webp",
      "image_media": {
        "alt_text": "Mail center with rows of mailboxes and covered walkway.",
        "public_id": "019d0214-a6bb-7668-8cd6-91de8bc51c18",
        "storage_key": "property/6767906449167129/019d0214-a6bb-7668-8cd6-91de8bc51c18.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient mail center with secure mailboxes and a covered walkway for resident use.",
      "link": "false",
      "alt_text": "Mail center with rows of mailboxes and covered walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (30).jpg"
    },
    {
      "id": "ec_978ed140db370754f4f9881d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-ab3d-73bd-94f7-26d2e15abfbb.webp",
      "image_media": {
        "alt_text": "Tuscany at Hunters Creek building entrance with a waterfall and lush greenery.",
        "public_id": "019d0214-ab3d-73bd-94f7-26d2e15abfbb",
        "storage_key": "property/6767906449167129/019d0214-ab3d-73bd-94f7-26d2e15abfbb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Tuscany at Hunters Creek, featuring a beautiful waterfall and exterior architecture that offers a luxurious living experience.",
      "link": "false",
      "alt_text": "Tuscany at Hunters Creek building entrance with a waterfall and lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (31).jpg"
    },
    {
      "id": "ec_53dc19b88370657ad00d2f8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0214-ac46-70e8-8f01-37b3129ec074.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with orange facade, balconies, and green lawn.",
        "public_id": "019d0214-ac46-70e8-8f01-37b3129ec074",
        "storage_key": "property/6767906449167129/019d0214-ac46-70e8-8f01-37b3129ec074.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious apartment building exterior featuring modern architecture, private balconies, and lush landscaping. Enjoy the beautiful outdoor spaces and vibrant community.",
      "link": "false",
      "alt_text": "Exterior of apartment building with orange facade, balconies, and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Tuscany_at_Faudree_Favorites (32).jpg"
    },
    {
      "id": "ec_03aea4cfb64e2b3a6e5e05fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/01a114f0-485d-743e-a96d-745077413027.webp",
      "image_media": {
        "alt_text": "Select 2 bedroom apartment homes starting at $1,560 on a 12 month lease with specials up to 1 month free.",
        "public_id": "01a114f0-485d-743e-a96d-745077413027",
        "storage_key": "property/6767906449167129/01a114f0-485d-743e-a96d-745077413027.webp",
        "width": 800,
        "height": 505
      },
      "title": "Apartment",
      "description": "Lease a 2-bedroom apartment home starting at $1,560 with specials up to 1 month free on a 12-month lease. Limited time offer. Contact the leasing office for details.",
      "link": "false",
      "alt_text": "Select 2 bedroom apartment homes starting at $1,560 on a 12 month lease with specials up to 1 month free.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Special (3009).png"
    },
    {
      "id": "ec_496b3389fbb34d747cb07ae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/01a114f0-485d-743e-a96d-745077413027.webp",
      "image_media": {
        "alt_text": "Select 2 bedroom apartment homes starting at $1,560 on a 12 month lease with specials up to 1 month free.",
        "public_id": "01a114f0-485d-743e-a96d-745077413027",
        "storage_key": "property/6767906449167129/01a114f0-485d-743e-a96d-745077413027.webp",
        "width": 800,
        "height": 505
      },
      "title": "Apartment",
      "description": "Lease a 2-bedroom apartment home starting at $1,560 with specials up to 1 month free on a 12-month lease. Limited time offer. Contact the leasing office for details.",
      "link": "false",
      "alt_text": "Select 2 bedroom apartment homes starting at $1,560 on a 12 month lease with specials up to 1 month free.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Special (3009).png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c26dbdd4-a478-4e74-baf8-1943d05011dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4001 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-2986-73ab-a8e8-9164ca84a5b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2986-73ab-a8e8-9164ca84a5b7",
        "storage_key": "property/6767906449167129/019d0216-2986-73ab-a8e8-9164ca84a5b7.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/odessa/4001-east-42nd-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=5970026171640045122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "31.8915449",
      "poi_longitude": "-102.3448821",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-272-8092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e340-756d-a26b-cfc196722c75",
        "storage_key": "property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHeVpSJ_P-4YRQt5jLCzL2VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fdac41b3-3e05-4188-b11e-734601a3dd98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "4221 N Grandview Ave, Odessa, TX 79762, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tasty steaks, ribs, and appetizers like potato skins and fried pickles. They also highlight the good value, fun atmosphere, and attentive service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-29c2-71d9-8016-77755085a151.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-29c2-71d9-8016-77755085a151",
        "storage_key": "property/6767906449167129/019d0216-29c2-71d9-8016-77755085a151.webp",
        "width": 1060,
        "height": 540
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/odessa?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=8987899989788825135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.8913756",
      "poi_longitude": "-102.3530079",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-550-9416",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e340-756d-a26b-cfc196722c75",
        "storage_key": "property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0U5otbI-4YRL5YZuGtvu3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_45c0ae74-a7ee-49b4-bd69-452bacfd84db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Cork & Pig Tavern",
      "poi_type": "Restaurants",
      "poi_address": "7260 E Texas 191 #204, #204, Odessa, TX 79762, USA",
      "poi_short_description": "Easygoing gastropub offering wood-fired pizza, American fare & many wines in contemporary digs.",
      "poi_long_description": "People say this bar and grill serves great food, including steak salad, salmon, and pizza. They also highlight the awesome staff, wonderful drinks, and enjoyable outdoor seating.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-843a-72d3-9fab-d40fe663f5ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-843a-72d3-9fab-d40fe663f5ac",
        "storage_key": "property/6767906449167129/019d0215-843a-72d3-9fab-d40fe663f5ac.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.corkandpig.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10563649003014404735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cork--pig-tavern",
      "poi_latitude": "31.9103301",
      "poi_longitude": "-102.2979444",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-272-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e35a-705a-848f-48e5f5b8a90a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e35a-705a-848f-48e5f5b8a90a",
        "storage_key": "property/6767906449167129/019d0215-e35a-705a-848f-48e5f5b8a90a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57JsLyvP-4YRfzqVtMyemZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_eac9b07a-bfab-40c8-a1ed-8ed73c0439dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Chick-Fil-A",
      "poi_type": "Restaurants",
      "poi_address": "106 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and ice cream. They also highlight the friendly staff and efficient service.\n\nOther reviews mention orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-2acb-77c9-8fd8-25899af778ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2acb-77c9-8fd8-25899af778ac",
        "storage_key": "property/6767906449167129/019d0216-2acb-77c9-8fd8-25899af778ac.webp",
        "width": 1280,
        "height": 1133
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/university-blvd-odessa?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13780749600994930487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.868249",
      "poi_longitude": "-102.379104",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 432-360-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e340-756d-a26b-cfc196722c75",
        "storage_key": "property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwxAmoLJ-4YRN6_oob8OP78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3c6e4f39-2136-4c6a-ad41-984d8972ddf6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Brantley Creek Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "3541 Faudree Rd, Odessa, TX 79765, USA",
      "poi_short_description": "Beloved barbecue joint serving up Texas-style smoked meats for lunch and dinner.",
      "poi_long_description": "People say this barbecue restaurant serves tender and juicy brisket, ribs, and sausage, as well as delicious banana pudding. They highlight the family-friendly atmosphere, live music, and fast service. They also like the friendly staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://brantleycreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10499946290500663442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brantley-creek-barbecue",
      "poi_latitude": "31.9063758",
      "poi_longitude": "-102.2848541",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-275-0037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e340-756d-a26b-cfc196722c75",
        "storage_key": "property/6767906449167129/019d0215-e340-756d-a26b-cfc196722c75.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6b627ZHP-4YRkvj4JYVNt5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_1ae94e5f-d08b-48a7-a3a8-2ec459757d61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "3801 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including quality meats and fresh produce. They also highlight the good prices, clean store, and friendly staff.\n\nOther reviews mention the parking lot can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-8a61-71e9-ad61-b739b0ecf343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-8a61-71e9-ad61-b739b0ecf343",
        "storage_key": "property/6767906449167129/019d0215-8a61-71e9-ad61-b739b0ecf343.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/odessa/42nd-st.-h-e-b-387?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=15246427008090309204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.891449",
      "poi_longitude": "-102.351012",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-362-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e7aa-71d0-9ec5-3018c46ade8a",
        "storage_key": "property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQCmQtTI-4YRVAIlt5UwltM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bcd78841-131f-4c78-8411-030baea480de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "El Rancho Supermercado",
      "poi_type": "Shopping & Retail",
      "poi_address": "1315 E 8th St, Odessa, TX 79761, USA",
      "poi_short_description": "Grocery store stocking a variety of Mexican staples, along with a restaurant and bakery.",
      "poi_long_description": "People say this supermarket offers a huge variety of food, including fresh produce, a large meat selection, and freshly cooked items. They also highlight the affordable prices, the clean environment, and the fast service.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-2e63-7171-99b1-7f517dbcc527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2e63-7171-99b1-7f517dbcc527",
        "storage_key": "property/6767906449167129/019d0216-2e63-7171-99b1-7f517dbcc527.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://elranchoinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=357353162596392067&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-rancho-supermercado",
      "poi_latitude": "31.859577",
      "poi_longitude": "-102.356425",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-332-4552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e7aa-71d0-9ec5-3018c46ade8a",
        "storage_key": "property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmeMluEjJ-4YRg5zr286S9QQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_5e61517d-a304-481d-9737-e83631263991",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Music City Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Old-school mall since 1980 offering kids' play areas, a food court, movie theater & indoor ice rink.",
      "poi_long_description": "People say this shopping center has a skating rink, play areas for kids, and a variety of dining options, including Mexican street tacos. They also highlight the family-friendly atmosphere with activities like an arcade and bungee jumping.\n\nSome reviews mention the mall can be in need of renovation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-90f3-76c1-b33a-72d328d3417f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-90f3-76c1-b33a-72d328d3417f",
        "storage_key": "property/6767906449167129/019d0215-90f3-76c1-b33a-72d328d3417f.webp",
        "width": 1080,
        "height": 668
      },
      "poi_business_url": "http://musiccitymall.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4647290278163924921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "music-city-mall",
      "poi_latitude": "31.8946218",
      "poi_longitude": "-102.3389494",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-550-2483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e7af-71fe-873b-7dd0cf1555d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e7af-71fe-873b-7dd0cf1555d0",
        "storage_key": "property/6767906449167129/019d0215-e7af-71fe-873b-7dd0cf1555d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPeKT_CvP-4YRuUcWtuJ9fkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2250133a-296d-4ae9-86d7-8ca76a58929e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3887 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of clothes, shoes, and other items. They also highlight the affordable prices and the friendly staff.\n\nSome reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-3199-741c-b396-0339ba6d2977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3199-741c-b396-0339ba6d2977",
        "storage_key": "property/6767906449167129/019d0216-3199-741c-b396-0339ba6d2977.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6295609250964392453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "31.8919896",
      "poi_longitude": "-102.3489827",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-362-2134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e7af-71fe-873b-7dd0cf1555d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e7af-71fe-873b-7dd0cf1555d0",
        "storage_key": "property/6767906449167129/019d0215-e7af-71fe-873b-7dd0cf1555d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJldx8DyvP-4YRBUplGEJ_Xlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f6522252-7b80-4d60-87b2-b24c5ec75b8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "4950 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Grocery chain featuring gourmet items and everyday essentials, plus a pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meat, and healthy, organic options. They highlight the clean and organized store, and the friendly, helpful staff. They also like the convenient location and extended hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-90e5-710c-8806-ca213fa05e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-90e5-710c-8806-ca213fa05e39",
        "storage_key": "property/6767906449167129/019d0215-90e5-710c-8806-ca213fa05e39.webp",
        "width": 1280,
        "height": 621
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/odessa/4950-e-42nd-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585564719479866515&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "31.891696",
      "poi_longitude": "-102.3343725",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-367-4976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e7aa-71d0-9ec5-3018c46ade8a",
        "storage_key": "property/6767906449167129/019d0215-e7aa-71d0-9ec5-3018c46ade8a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4FXKSbP-4YRk0SNzoTpg00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c9334f0a-69ac-4878-8775-6157f21f9478",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "The University of Texas Permian Basin",
      "poi_type": "Education",
      "poi_address": "4901 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-97ee-733e-aa78-f500d16e4255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-97ee-733e-aa78-f500d16e4255",
        "storage_key": "property/6767906449167129/019d0215-97ee-733e-aa78-f500d16e4255.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "http://www.utpb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037060805297192125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-texas-permian-basin",
      "poi_latitude": "31.8876067",
      "poi_longitude": "-102.3230046",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-552-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ec26-7221-b68d-d4b7c655e529.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-ec26-7221-b68d-d4b7c655e529",
        "storage_key": "property/6767906449167129/019d0215-ec26-7221-b68d-d4b7c655e529.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs0RSpufO-4YRvTwUndUVj94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_be7b2382-7791-40c1-b4a3-afa92f504e29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Ratliff Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1862 E Yukon Rd, Odessa, TX 79765, USA",
      "poi_short_description": "Venue for sports games and other events featuring a playback screen and restroom facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-34e1-7678-b3e8-daa587e7661b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-34e1-7678-b3e8-daa587e7661b",
        "storage_key": "property/6767906449167129/019d0216-34e1-7678-b3e8-daa587e7661b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17546804916744811992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ratliff-stadium",
      "poi_latitude": "31.920729",
      "poi_longitude": "-102.3644952",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-456-9059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-5c15-7283-9794-9b8a40a0fd6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-5c15-7283-9794-9b8a40a0fd6d",
        "storage_key": "property/6767906449167129/019d0216-5c15-7283-9794-9b8a40a0fd6d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL6NcQqPI-4YR2PWm1RrGgvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1e337adb-80a3-4da5-b2dd-e25e517b61e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Ellen Noël Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "4909 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "Fine arts center with various exhibits, a sculpture garden & cultural programs including lectures.",
      "poi_long_description": "People say this art museum offers thoughtfully curated exhibits showcasing local artwork and traveling collections. They highlight the calm and inviting atmosphere, and the friendly and knowledgeable staff. They also like the free admission.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-a9aa-7389-9428-5557f2473b86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-a9aa-7389-9428-5557f2473b86",
        "storage_key": "property/6767906449167129/019d0215-a9aa-7389-9428-5557f2473b86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.noelartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=685406071730754092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ellen-nol-art-museum",
      "poi_latitude": "31.8826259",
      "poi_longitude": "-102.3186036",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-550-9696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-ed47-76b0-b370-f4e62abdd983",
        "storage_key": "property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVVnqOfO-4YRLFJo2DANgwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_a6a3ac77-117c-4654-b1fc-d5080d8abd5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "4101 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including go-karts, trampolines, and slides, and is a great place for birthday parties.\n\nOther reviews mention the park can be unfinished and the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-379d-7731-949f-f49004103b67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-379d-7731-949f-f49004103b67",
        "storage_key": "property/6767906449167129/019d0216-379d-7731-949f-f49004103b67.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.urbanair.com/texas-odessa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4406183542498196917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.8951345",
      "poi_longitude": "-102.3376817",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-296-5067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0uxBB7P-4YRtf3GQZboJT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_56dcb661-c327-450c-801a-09de7b08e43b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Midland Army Air Field Museum Hangar",
      "poi_type": "Entertainment",
      "poi_address": "9600 Wright Dr, Midland, TX 79706, USA",
      "poi_short_description": "Visitors to this free museum inside the airport can see a variety of historical military aircraft.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-37a4-715f-928c-4728a3255d7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-37a4-715f-928c-4728a3255d7e",
        "storage_key": "property/6767906449167129/019d0216-37a4-715f-928c-4728a3255d7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.highskywing.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12508760768526204053&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-army-air-field-museum-hangar",
      "poi_latitude": "31.9418417",
      "poi_longitude": "-102.2146406",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-254-6182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-ed47-76b0-b370-f4e62abdd983",
        "storage_key": "property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQaX0n7Q-4YRlbxYDKULmK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6e3a419d-f337-432e-8112-7ab1ca7f2d2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Presidential Archives",
      "poi_type": "Entertainment",
      "poi_address": "4919 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "Portraits & paperwork pertaining to many United States presidents in a university archive.",
      "poi_long_description": "Portraits & paperwork pertaining to many United States presidents in a university archive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ae96-723e-8e3d-970107ba9b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ae96-723e-8e3d-970107ba9b5b",
        "storage_key": "property/6767906449167129/019d0215-ae96-723e-8e3d-970107ba9b5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11384095959667910952&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "presidential-archives",
      "poi_latitude": "31.8826067",
      "poi_longitude": "-102.3185975",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-363-7737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-ed47-76b0-b370-f4e62abdd983",
        "storage_key": "property/6767906449167129/019d0215-ed47-76b0-b370-f4e62abdd983.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjY_Zj-bO-4YRKCn3tPVu_J0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1151fc60-814b-4836-980e-f27626f8d172",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Crunch Fitness - Odessa",
      "poi_type": "Health and Wellness",
      "poi_address": "2008 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Relaxed, family-focused chain offers a variety of fitness classes, plus equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-c286-7466-b456-d4c88c26848c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c286-7466-b456-d4c88c26848c",
        "storage_key": "property/6767906449167129/019d0215-c286-7466-b456-d4c88c26848c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/odessa",
      "poi_directions_map_url": "https://maps.google.com/?cid=10724134956650516741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---odessa",
      "poi_latitude": "31.8879306",
      "poi_longitude": "-102.3533229",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-305-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc_MtjrJ-4YRBdGAluzH05Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_463e9f23-3626-4aba-b9b6-c668cae7cc82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "West Texas Emergency Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "601 N Grandview Ave, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wtxvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3887297560723694288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-texas-emergency-veterinary-clinic",
      "poi_latitude": "31.8588025",
      "poi_longitude": "-102.3453719",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-614-9204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5IwRLPO-4YR0KItI4l08jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_82a436c2-9674-4aa8-acba-67f1f1db81f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Statik Indoor Soccer",
      "poi_type": "Health and Wellness",
      "poi_address": "6695 Andrews Hwy, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-3caf-724b-b94c-38955b140d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3caf-724b-b94c-38955b140d40",
        "storage_key": "property/6767906449167129/019d0216-3caf-724b-b94c-38955b140d40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.statiksoccer.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17865956884807511516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "statik-indoor-soccer",
      "poi_latitude": "31.9063189",
      "poi_longitude": "-102.3930723",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-553-6230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyGua2DI-4YR3G1l-yCh8Pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f031c1e6-9fce-4f9a-9388-948bfdb6a3a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "The garage barbershop Odessa(walk-ins welcome)",
      "poi_type": "Health and Wellness",
      "poi_address": "4555 E University Blvd Suite B3, Odessa, TX 79762, USA",
      "poi_short_description": "Professional barbershop offering haircuts including fades in the Market Place.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-3ef4-7678-8f74-f866b729e510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3ef4-7678-8f74-f866b729e510",
        "storage_key": "property/6767906449167129/019d0216-3ef4-7678-8f74-f866b729e510.webp",
        "width": 1239,
        "height": 1280
      },
      "poi_business_url": "https://link.booksy.com/Thegaragebarbershopodessa",
      "poi_directions_map_url": "https://maps.google.com/?cid=10794819340359352417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-garage-barbershop-odessawalk-ins-welcome",
      "poi_latitude": "31.8800982",
      "poi_longitude": "-102.3314938",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-248-6358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyddxEEnP-4YRYcCiJP_mzpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_87a24f90-c047-4f03-8ac0-634c15ce2668",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "MCH Mission Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8050 TX-191 Frontage, Odessa, TX 79765, USA",
      "poi_short_description": "Relaxed, gym featuring a lap pool, a hot tub and a steam room, along with showers.",
      "poi_long_description": "People say this gym offers a variety of amenities, including a pool, sauna, hot tub, and gym, and provides towels and shampoo. They highlight the accommodating staff and the quiet environment suitable for self-care. They also like the friendly and negotiable service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-41b7-72bf-84f2-0894ec2c19d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-41b7-72bf-84f2-0894ec2c19d3",
        "storage_key": "property/6767906449167129/019d0216-41b7-72bf-84f2-0894ec2c19d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mchodessa.com/locations/mch-mission-fitness/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14544310957531334770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mch-mission-fitness",
      "poi_latitude": "31.921274",
      "poi_longitude": "-102.288604",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-640-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR669lpnP-4YRcgh6vsHF18k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ae9cc38-3d00-4a68-a4e9-00a3d0f38431",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 E 8th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and is never overcrowded.\n\nOther reviews mention the equipment can be worn and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-3f2e-7197-b29e-8712ff8bfd1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3f2e-7197-b29e-8712ff8bfd1a",
        "storage_key": "property/6767906449167129/019d0216-3f2e-7197-b29e-8712ff8bfd1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/odessa-texas-3966/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3966",
      "poi_directions_map_url": "https://maps.google.com/?cid=18073146451444535069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "31.8601807",
      "poi_longitude": "-102.353769",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-272-0071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ679GNknJ-4YRHY_2I_G20Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1a6a50e4-b40c-4619-9dad-1d1cb5419d4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Fitness 1440 Odessa",
      "poi_type": "Health and Wellness",
      "poi_address": "627 E 42nd St, Odessa, TX 79762, USA",
      "poi_short_description": "Clean gym, sauna and hot tubs, plus friendly staff.",
      "poi_long_description": "People say this fitness center offers a variety of equipment and a good workout atmosphere. They highlight the gym is clean and not too crowded. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-4568-734f-a83c-82bc9cfcbfc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4568-734f-a83c-82bc9cfcbfc2",
        "storage_key": "property/6767906449167129/019d0216-4568-734f-a83c-82bc9cfcbfc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitness1440.com/odessa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3142578124638458335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-1440-odessa",
      "poi_latitude": "31.8852268",
      "poi_longitude": "-102.3750264",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-307-6642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQu2OHHJ-4YR3xH9fSeunCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_1242eb60-a08b-43f3-8adc-01567d63a667",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Blessed Barbers Odessa (WALK-INS WELCOME)",
      "poi_type": "Health and Wellness",
      "poi_address": "6018 Eastridge Rd, Odessa, TX 79762, USA",
      "poi_short_description": "Upscale barber shop offering classic and modern haircuts as well as beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-463e-743c-a5c2-06688d258f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-463e-743c-a5c2-06688d258f4d",
        "storage_key": "property/6767906449167129/019d0216-463e-743c-a5c2-06688d258f4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13593449650251907633&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blessed-barbers-odessa-walk-ins-welcome",
      "poi_latitude": "31.8937312",
      "poi_longitude": "-102.3160601",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fSW7GLP-4YRMUJsi2-ipbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7ffb0e9e-294e-4e0c-a390-19ada545794c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "4103 Faudree Rd Ste 120, Odessa, TX 79765, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-463e-743c-a5c2-032dfc475271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-463e-743c-a5c2-032dfc475271",
        "storage_key": "property/6767906449167129/019d0216-463e-743c-a5c2-032dfc475271.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/tx/odessa/4103-faudree-rd?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1908311911956510995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "31.9164974",
      "poi_longitude": "-102.290418",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-235-7019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTEOgpPP-4YRE3nQwJKvexo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_282ea754-9c62-4d36-81f2-05c0d1e0f8cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Odessa",
      "poi_type": "Health and Wellness",
      "poi_address": "6113 TX-191, Odessa, TX 79762, USA",
      "poi_short_description": "Chain hair salon specializing in men's and boys' haircuts with sports on TV and online check-in.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-4943-75bd-8dc8-b16e51361eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4943-75bd-8dc8-b16e51361eab",
        "storage_key": "property/6767906449167129/019d0216-4943-75bd-8dc8-b16e51361eab.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-tx-odessa-tx731?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=18378323620007107583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-odessa",
      "poi_latitude": "31.898044",
      "poi_longitude": "-102.3169283",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-362-0667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3ntKhnP-4YR_9uxufXrDP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9d51536a-efdc-4d2b-8cff-449479276c14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Odessa Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "520 E 6th St, Odessa, TX 79761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-b70a-722c-a06f-49db110accba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b70a-722c-a06f-49db110accba",
        "storage_key": "property/6767906449167129/019d0215-b70a-722c-a06f-49db110accba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.odessaregionalmedicalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15794145150316007758&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "odessa-regional-medical-center",
      "poi_latitude": "31.8522743",
      "poi_longitude": "-102.3638212",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-582-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f077-75d7-a9b2-5981e0f315e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f077-75d7-a9b2-5981e0f315e1",
        "storage_key": "property/6767906449167129/019d0215-f077-75d7-a9b2-5981e0f315e1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTtAlFzJ-4YRTlGLT1UTMNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_8cc5dff1-351f-4401-909f-1649173ad6fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Basin Orthopedic Surgical Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Parks Legado Rd, Odessa, TX 79765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-4d54-71f3-b13e-952d277fb0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4d54-71f3-b13e-952d277fb0e5",
        "storage_key": "property/6767906449167129/019d0216-4d54-71f3-b13e-952d277fb0e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.basinorthopedics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10110995386428367806&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "basin-orthopedic-surgical-specialists",
      "poi_latitude": "31.9102782",
      "poi_longitude": "-102.2922041",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-332-2663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f077-75d7-a9b2-5981e0f315e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f077-75d7-a9b2-5981e0f315e1",
        "storage_key": "property/6767906449167129/019d0215-f077-75d7-a9b2-5981e0f315e1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ63jgEE_J-4YRviOtzbt4UYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_8a719ffd-85dc-4865-a12c-0641366e75c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Ratliff Ranch Golf Links",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7500 N Grandview Ave, Odessa, TX 79765, USA",
      "poi_short_description": "Public golf course with driving range featuring well-maintained facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-c91b-70d1-810f-5b9de69aa777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c91b-70d1-810f-5b9de69aa777",
        "storage_key": "property/6767906449167129/019d0215-c91b-70d1-810f-5b9de69aa777.webp",
        "width": 1280,
        "height": 1116
      },
      "poi_business_url": "http://www.ratliffranchgolfodessa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=100977475024200293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ratliff-ranch-golf-links",
      "poi_latitude": "31.9236013",
      "poi_longitude": "-102.3608895",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-550-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f172-770d-9b1b-5e1db232d861.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f172-770d-9b1b-5e1db232d861",
        "storage_key": "property/6767906449167129/019d0215-f172-770d-9b1b-5e1db232d861.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf88uSqTI-4YRZSIigXq-ZgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_512be8f1-51fe-4838-93a6-577d68bdad1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Sherwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4819 N Everglade Ave, Odessa, TX 79762, USA",
      "poi_short_description": "Park featuring an outdoor aquatic center & a playground, plus a bike/skate park & baseball.",
      "poi_long_description": "Park featuring an outdoor aquatic center & a playground, plus a bike/skate park & baseball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ce4d-7625-a3a0-a328676a9f52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ce4d-7625-a3a0-a328676a9f52",
        "storage_key": "property/6767906449167129/019d0215-ce4d-7625-a3a0-a328676a9f52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.odessa-tx.gov/540/Facilities-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3933105874804604259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sherwood-park",
      "poi_latitude": "31.8890956",
      "poi_longitude": "-102.3757178",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f188-759b-bcce-5cc40074eaf6",
        "storage_key": "property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJidbAzeHI-4YRY_26Y_QylTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_80212340-935d-495c-803e-e6a6eef12587",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Jim Parker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3100 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "City park with a children's playground, as well as facilities for baseball and tennis.",
      "poi_long_description": "People say this city park offers roller slides and ball diamonds with covered bleachers. They highlight the park is a great place for freeze tag and a fun workout. They also like the friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-4fd1-71ab-8229-87b33b67708f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4fd1-71ab-8229-87b33b67708f",
        "storage_key": "property/6767906449167129/019d0216-4fd1-71ab-8229-87b33b67708f.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9896161726104993025&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jim-parker-park",
      "poi_latitude": "31.8733508",
      "poi_longitude": "-102.3524727",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f188-759b-bcce-5cc40074eaf6",
        "storage_key": "property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhaj_hjHJ-4YRAf1NZKg6Vok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ef5954e7-d5d6-4a22-ab15-0e07cc1e0870",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "UTPB Park Sprayground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "TX-191 &, TX-338 Loop, Odessa, TX 79762, USA",
      "poi_short_description": "Park featuring a playground and a splash area for cooling off and sliding.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-ced1-752b-94fd-50c98bbb9fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-ced1-752b-94fd-50c98bbb9fe4",
        "storage_key": "property/6767906449167129/019d0215-ced1-752b-94fd-50c98bbb9fe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.odessa-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6897058128513978429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "utpb-park-sprayground",
      "poi_latitude": "31.8925816",
      "poi_longitude": "-102.3216163",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-368-3548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f188-759b-bcce-5cc40074eaf6",
        "storage_key": "property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVqdTO-4YRPdBLYdNFt18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1d2ab8cd-8b5d-4e31-a431-79519ced849b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Woodson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1010 Martin Luther King, Jr. St, Odessa, TX 79761, USA",
      "poi_short_description": "Relaxed park with a playground, a swimming pool and a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-d39e-76a2-9388-ebffcbee33d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-d39e-76a2-9388-ebffcbee33d5",
        "storage_key": "property/6767906449167129/019d0215-d39e-76a2-9388-ebffcbee33d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9775331579759261237&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodson-park",
      "poi_latitude": "31.84400759999999",
      "poi_longitude": "-102.3510552",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f188-759b-bcce-5cc40074eaf6",
        "storage_key": "property/6767906449167129/019d0215-f188-759b-bcce-5cc40074eaf6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbgjk97J-4YRNXY1pUf0qIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_12a9b8f4-dfe8-47c4-b4a5-073911bcf7bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Midland International Air & Space Port",
      "poi_type": "Transportation & Transit",
      "poi_address": "9506 La Force Blvd, Midland, TX 79706, USA",
      "poi_short_description": "Airport with a terminal housing the 1911 Pliska Aeroplane, the first airplane built in Texas.",
      "poi_long_description": "Visitors say this airport is clean, well-maintained, and easy to navigate, with friendly and helpful staff. They also highlight the efficient check-in and security processes, as well as the reasonable parking rates.\n\nSome reviews mention the TSA lines can be long, especially during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-d72a-7039-9aeb-e6fdcfddadb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-d72a-7039-9aeb-e6fdcfddadb3",
        "storage_key": "property/6767906449167129/019d0215-d72a-7039-9aeb-e6fdcfddadb3.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.flymaf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9536195868847421991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midland-international-air--space-port",
      "poi_latitude": "31.9417386",
      "poi_longitude": "-102.2047497",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-560-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f18b-70be-ae9d-4578a59e933e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f18b-70be-ae9d-4578a59e933e",
        "storage_key": "property/6767906449167129/019d0215-f18b-70be-ae9d-4578a59e933e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQSBGYDQ-4YRJ7oyJ55fV4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_5c4ef423-383b-458b-83c6-a31e983e9473",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Texas Aero LLC",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 E Terminal Dr, Odessa, TX 79765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-54b0-754f-8689-495b170959d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-54b0-754f-8689-495b170959d0",
        "storage_key": "property/6767906449167129/019d0216-54b0-754f-8689-495b170959d0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12653405900927440727&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-aero-llc",
      "poi_latitude": "31.9227949",
      "poi_longitude": "-102.3927357",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-367-5881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-f18b-70be-ae9d-4578a59e933e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-f18b-70be-ae9d-4578a59e933e",
        "storage_key": "property/6767906449167129/019d0215-f18b-70be-ae9d-4578a59e933e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WoIkn_J-4YRV5ecU6Dtma8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_034c434b-0112-4ee0-8476-443151c5bcfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Summit ESP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11722 W Hwy 80 E, Odessa, TX 79765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.summitesp.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=13292880393838837699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summit-esp",
      "poi_latitude": "31.9116743",
      "poi_longitude": "-102.2393293",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-563-7040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeanYOTrQ-4YRw7-EHErMebg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9257d9de-4e45-4dbc-962f-6b918d133f0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "TechnipFMC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8950 E Interstate 20, Odessa, TX 79766, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-5341-7624-a515-39abe3c8377a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-5341-7624-a515-39abe3c8377a",
        "storage_key": "property/6767906449167129/019d0216-5341-7624-a515-39abe3c8377a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://technipfmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5723490244819108751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "technipfmc",
      "poi_latitude": "31.8885784",
      "poi_longitude": "-102.2586232",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-381-9706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0JnainO-4YRj0PbpQ3sbU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_db7300b3-a000-434b-92a6-a37de1102c65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Gordon Technologies LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Odessa, TX 79766, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://gordontechnologiesllc.com/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7363383062206994876&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gordon-technologies-llc",
      "poi_latitude": "31.8885154",
      "poi_longitude": "-102.249588",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJga2iBZTR-4YRvNn51-H9L2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0d417477-38cf-48ed-92bb-8b567599879e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Fmc Technologies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8950 E Interstate 20, Odessa, TX 79766, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-55c3-7258-8422-d43fdf2d2994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-55c3-7258-8422-d43fdf2d2994",
        "storage_key": "property/6767906449167129/019d0216-55c3-7258-8422-d43fdf2d2994.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.technipfmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6536080906286862477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fmc-technologies",
      "poi_latitude": "31.8884958",
      "poi_longitude": "-102.2577367",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-231-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe577ijO-4YRjRBxYvTStFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6f0ac841-257c-4797-81a1-20fe8edbe204",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "custom",
      "poi_name": "Extract Production Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10810 W County Rd 77, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-5627-7169-8575-e56e30fd8510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-5627-7169-8575-e56e30fd8510",
        "storage_key": "property/6767906449167129/019d0216-5627-7169-8575-e56e30fd8510.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.extractproduction.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9614000841045649340&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "extract-production-services",
      "poi_latitude": "31.9794055",
      "poi_longitude": "-102.2442263",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-938-6828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-e31f-727d-bdd7-5267dd58afba",
        "storage_key": "property/6767906449167129/019d0215-e31f-727d-bdd7-5267dd58afba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSH-BXrb-4YRvCfV6NPKa4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3b4ac62eb5cd9c05372c6100",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f470e89cc6aaa1a2e63558d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1b7181712243c351f9029f9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b49e78d8f0745ae4e697d10e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c0638273a10030e431460e03",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b2118955a0a95b47714c2cb9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_fd8b5e58-6ec1-4c3d-a772-cdd38aeb44b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "rating": "5.0",
      "name": "Fatima Billoo",
      "text": "I recently completed my move from an apartment on Faudree Road, and I often find myself wishing I had discovered Tuscany a year earlier. I was actually the one who introduced Tuscany to my brother when he moved from California. When I later became unwell, I stayed at his place for a while, and within just a few days I realized how comfortable and welcoming the apartment truly was.\n\nI couldn’t help but fall in love with the beautiful entrance and the wonderful sense of community throughout the complex. That experience made me determined to find an apartment here for myself. I began searching for the ideal unit—one filled with ample natural sunlight to support both my physical and mental well-being.\n\nThroughout this process, Raymond was always ready to help, accompanying me on tours of different apartments across the complex for nearly three to four weeks. I was genuinely moved by the courtesy and professionalism of everyone involved. Eventually, during one of my visits, the owner of the complex suggested an apartment that perfectly matched what I had been searching for. Despite their very busy schedules, the team was incredibly supportive and made the entire moving process smooth and stress-free.\n\nNow that I’ve settled in, I’m truly grateful for the quality of the apartment and the beautiful view from the galley. Living alone no longer feels lonely, especially with the calming view from my balcony. I have nothing but good things to say about Tuscany—it truly feels like home.",
      "date": "2025-12-24",
      "title": ""
    },
    {
      "id": "custom_cdeb8369-dd3e-4237-8e5e-e6deeb84b67e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "rating": "5.0",
      "name": "Alicia Dorado",
      "text": "There are just no words for how amazing the staff is! I have been working with Skyler for almost two months as we are moving our corporate apartment from the Faudree Ranch (I don't recommend) over to the Tuscany at Faudree. The first HUGE difference is just the response time. They actually answer the phone and respond to emails which felt amazing after the neglect we've endured at the previous complex. The personal attention is also amazing. While I don't want to admit to being a wee bit scatterbrained at times, Skyler had the patience of a saint with me, he explained everything in such detail, kept impeccable records, and thank goodness had a much better memory than I did. Everything went so smoothly and I was able to get my guys transitioned without a hitch. When it came time to come in to actually get the keys and tour the apartment, I had the pleasure of meeting Monique, and when I say I think that woman literally exudes spun sugar, it is no exaggeration. She was so sweet and kept me company while I waited for Skyler to get back from walking the property. He had everything printed, organized, and ready to go. The apartment was lovely, the grounds were so well kept, and all in all the entire experience was such a joy compared to what we had previously been through. I am excited to be doing business with them now and in the future. Kudos to them and their team!",
      "date": "2025-12-15",
      "title": ""
    },
    {
      "id": "custom_3ec455a5-501f-46c3-acb1-66e564827155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "rating": "5.0",
      "name": "Destiny Clevenger",
      "text": "I can’t say enough good things about Tuscany at Faudree and the management team. After recently experiencing a flood, they were incredibly supportive and worked quickly to get me comfortable in a new space. The entire process was handled with care and urgency, which made a stressful situation so much easier.\n\nRaymond and Skyler have been amazing throughout everything — their communication has been clear, consistent, and reassuring, and they’ve both been genuinely kind and understanding. It really shows that they care about their residents. I’m very grateful for how everything was handled and highly recommend this complex.",
      "date": "2026-01-03",
      "title": ""
    },
    {
      "id": "custom_6802f15f-b68f-4d2f-87cd-45aaaabcdc50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "rating": "5.0",
      "name": "T. VanNatta",
      "text": "We really enjoyed our time living at this apartment community. The building is a bit older, but it’s well cared for and has everything you need—like a nice pool, a workout room, and even personal garages, which was a big plus. The rooms are spacious.The area is quiet and the neighbors were always friendly, making it feel like home. Staff walked the property daily making sure the aesthetics of the property was up to par.They hosted fun events for residents which consisted of raffles and snacks. The surrounding area has great places to eat and shop.\n\nMaintenance was responsive and handled minor issues quickly, which we really appreciated. Skylar, the property manager as well as staff were always professional, kind, and easy to communicate with—he made sure everything ran smoothly. Overall, a great place to live if you’re looking for a comfortable, well-managed community with a friendly atmosphere. Ps. We lived there since April and sadly had to relocate due to my husband’s job.",
      "date": "2025-10-31",
      "title": ""
    },
    {
      "id": "custom_b8fd0708-85d5-4436-bd28-bff3355b8c18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "rating": "5.0",
      "name": "Kat Goede",
      "text": "This apartment complex has been the best one I’ve lived in and dealt with ever. Communication with the leasing office is the easiest I’ve ever dealt with. All of the office staff are so kind and helpful everytime we speak to them! Maintenance is taken care as fast as they are able to and the management here is top tier! Highly recommend this apartment complex",
      "date": "2025-12-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_45c95167712c05be90a4192c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-6052-7538-87ae-45f80170c6a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-6052-7538-87ae-45f80170c6a7",
        "storage_key": "property/6767906449167129/019ddb29-6052-7538-87ae-45f80170c6a7.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "Montebello",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/407363633"
    },
    {
      "id": "ec_0b85b3089db512da0e1e4272",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-6100-7665-97df-fd6f33a8ad6b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-6100-7665-97df-fd6f33a8ad6b",
        "storage_key": "property/6767906449167129/019ddb29-6100-7665-97df-fd6f33a8ad6b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Toscana",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sVP2M9DYXjP"
    },
    {
      "id": "ec_543896f64ed597453ddc7995",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-60e9-778b-bf6f-81715ed2dde4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-60e9-778b-bf6f-81715ed2dde4",
        "storage_key": "property/6767906449167129/019ddb29-60e9-778b-bf6f-81715ed2dde4.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "Siena",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/624860053"
    },
    {
      "id": "ec_35fc62f110f8b286e25d1e76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-6256-758d-8c9a-30f387249faa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-6256-758d-8c9a-30f387249faa",
        "storage_key": "property/6767906449167129/019ddb29-6256-758d-8c9a-30f387249faa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Arezzo",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sy7uHnMBTPN"
    },
    {
      "id": "ec_16980dfee699fe0224e35ffc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-606f-76af-bf8d-956696b2314f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-606f-76af-bf8d-956696b2314f",
        "storage_key": "property/6767906449167129/019ddb29-606f-76af-bf8d-956696b2314f.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "Centovalli",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/407363459"
    },
    {
      "id": "ec_d92d5df4f1bc14192492ca9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019ddb29-68a5-7618-b3b3-b134daeed2e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddb29-68a5-7618-b3b3-b134daeed2e1",
        "storage_key": "property/6767906449167129/019ddb29-68a5-7618-b3b3-b134daeed2e1.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "Villa Medici/Carrara",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/649703456"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db66e-2516-75e3-ba2f-7b4771f0b112",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Tuscany at Faudree",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-home-washer-dryer-odessa",
      "search_query": "luxury apartments with in-home washer dryer odessa tx",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Home Washer Dryer",
      "h2_subtitle": "Discover luxury living in Odessa, TX. Enjoy the convenience of an in-home washer dryer at Tuscany Apartments today.",
      "page_copy": "Tuscany Apartments in Odessa, TX, offers a taste of luxury combined with practical amenities. Enjoy the modern convenience of an in-home washer dryer, a feature that is standard in our upscale apartments. Located in the vibrant neighborhood near Midland & Odessa, Tuscany Apartments prides itself on providing high-end living spaces to fit your lifestyle.\n\nBeyond the practical benefits like tile flooring and built-in computer stations, Tuscany Apartments enhances your living experience with its on-site media center offering movies and popcorn, perfect for a relaxed evening in. High-speed Wi-Fi is also available, ensuring you stay connected, whether working from home or streaming your favorite shows. Experience the upscale charm and functionality of Tuscany Apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Home Washer Dryer",
      "seo_description": "Experience luxury living with in-home washer dryer at Tuscany in Odessa, TX. Enjoy modern amenities and upscale comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "gated-community-pool-spa-ector-county",
      "search_query": "gated community with pool and spa ector county",
      "category": "Amenity",
      "h1_title": "Gated Community with Pool and Spa",
      "h2_subtitle": "Enjoy life in a gated community in Ector County. Tuscany Apartments offers a pool and spa for residents' relaxation and enjoyment.",
      "page_copy": "Tuscany Apartments, located in the heart of Ector County, provides a secure and serene gated community experience. Residents have exclusive access to a luxurious pool and spa, perfect for unwinding after a long day. This community is thoughtfully designed to enhance your lifestyle with a host of amenities.\n\nIn addition to relaxation facilities, residents can enjoy modern comforts such as tile flooring, built-in computer stations, and high-speed Wi-Fi. The neighborhood of Midland & Odessa offers a vibrant backdrop for Tuscany Apartments, ensuring you have everything you need within reach. Discover a blend of relaxation and convenience at this premier address in Ector County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community with Pool and Spa in Ector County",
      "seo_description": "Tuscany in Ector County offers a gated community with a luxurious pool and spa. Enjoy secure living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-parks-odessa",
      "search_query": "pet friendly apartments with dog parks odessa tx",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Parks",
      "h2_subtitle": "Find pet-friendly living in Odessa, TX. Tuscany Apartments welcomes pets and offers access to nearby dog parks.",
      "page_copy": "At Tuscany Apartments in Odessa, TX, we understand that pets are part of the family. That’s why our community is pet-friendly and our location provides easy access to nearby dog parks, ensuring your furry friends have plenty of room to roam and play. Enjoy the peace of mind that comes with knowing your pets are welcome here.\n\nOur residents benefit from the numerous amenities designed to enhance both human and pet experiences, including spacious living areas with tile flooring and modern conveniences like built-in computer stations. Situated in the Midland & Odessa neighborhood, Tuscany Apartments offers a perfect blend of comfort, convenience, and pet-friendly amenities to make you and your pets feel at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Parks",
      "seo_description": "Tuscany offers pet-friendly living in Odessa, TX, with access to dog parks. Enjoy modern living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "fitness-center-gym-apartments-midland-odessa",
      "search_query": "fitness center and gym apartments midland odessa",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center and Gym",
      "h2_subtitle": "Discover modern living in Midland Odessa. Tuscany Apartments features a state-of-the-art fitness center and gym for residents.",
      "page_copy": "Tuscany Apartments, located in the vibrant Midland Odessa area, offers residents access to a state-of-the-art fitness center and gym. Whether you're a fitness enthusiast or just beginning your wellness journey, our facility is equipped to meet your needs with modern equipment and a welcoming atmosphere.\n\nApart from fitness amenities, Tuscany Apartments provides a variety of features that enhance everyday living, such as tile flooring, high-speed Wi-Fi, and built-in computer stations. Our community is designed to offer both convenience and luxury, allowing you to enjoy an active lifestyle while being close to everything in the Midland & Odessa neighborhood. Experience the best of both worlds at Tuscany Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center and Gym",
      "seo_description": "Enjoy luxurious apartments with a fitness center and gym in Midland Odessa at Tuscany. Stay fit and active with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-high-speed-internet-79765",
      "search_query": "apartments with air conditioning and high speed internet 79765",
      "category": "Amenity",
      "h1_title": "Apartments with AC & High-Speed Internet",
      "h2_subtitle": "Stay cool and connected in 79765. Tuscany Apartments offers air conditioning and high-speed internet for a modern living experience.",
      "page_copy": "Situated in the vibrant area of 79765, Tuscany Apartments provides a comfortable living environment with essential amenities like air conditioning and high-speed internet. Our community ensures that residents can relax in a cool environment while staying effortlessly connected to their digital lives.\n\nIn addition to climate control and connectivity, Tuscany Apartments offers an array of amenities including tile flooring and built-in computer stations. Located in the heart of the Midland & Odessa area, our community provides a blend of comfort, convenience, and modern living, making Tuscany Apartments the ideal choice for those seeking an elevated lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with AC & High-Speed Internet",
      "seo_description": "Tuscany in 79765 offers apartments with air conditioning and high-speed internet. Enjoy comfort and connectivity in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-in-odessa-tx",
      "search_query": "one bedroom apartments in odessa tx",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Odessa, TX",
      "h2_subtitle": "Discover the charm of Odessa, TX with Tuscany Apartments. Our one-bedroom units blend comfort and modern design.",
      "page_copy": "Tuscany Apartments invites you to explore our spacious one-bedroom apartments in the heart of Odessa, TX. Our thoughtfully designed homes offer a perfect blend of comfort and modern living, featuring stylish tile flooring and convenient built-in computer stations, making them ideal for any lifestyle.\n\nLocated in the lively Midland & Odessa neighborhood, Tuscany Apartments provides easy access to local amenities, ensuring everything you need is just a short drive away. Enjoy a host of community features, from our media center stocked with movies and popcorn to reliable Wi-Fi connectivity, all designed to enhance your living experience. Discover the ideal one-bedroom apartment in Odessa at Tuscany.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Odessa, TX",
      "seo_description": "Explore one-bedroom apartments at Tuscany in Odessa, TX. Modern design and amenities offer comfortable living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167129",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-ector-county",
      "search_query": "two bedroom apartments ector county",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Ector County",
      "h2_subtitle": "Experience spacious living in Ector County. Tuscany Apartments offers modern two-bedroom units with exceptional amenities.",
      "page_copy": "Nestled in the heart of Ector County, Tuscany Apartments provides spacious and well-designed two-bedroom apartments ideal for families or roommates. Each unit is equipped with modern amenities such as tile flooring and built-in computer stations, ensuring a comfortable and stylish living experience.\n\nSituated conveniently near Midland & Odessa, our community offers residents easy access to a vibrant neighborhood while enjoying the tranquility of Ector County. With features like a media center complete with movies and popcorn, and high-speed Wi-Fi, Tuscany Apartments provides a lifestyle of relaxation and convenience. Discover your perfect two-bedroom home at Tuscany Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Ector County",
      "seo_description": "Find modern two-bedroom apartments in Ector County at Tuscany. Enjoy spacious living with high-quality amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308816831"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183299"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5ZRBP4K8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "8dcd2514-b1f0-4be7-8c2a-265731946085"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/68dc4d2a-f03e-48e6-bb3d-58b4f61efc91/app.js?property=68dc4d2a-f03e-48e6-bb3d-58b4f61efc91&propertyName=Tuscany+at+Faudree&channelUuid=c248f994-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55405269665"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZFaENNMXNLZHcwenk2WE5wZ2g0U3c9PSIsInZhbHVlIjoianFKTFRpckhKWTdvUnRueGhYOVNwUT09IiwibWFjIjoiNWZjZTg1M2MxOGUxMTc1ODg2ZTcwMzljYjM2Yjc5MDQ0MjMzNTg3Y2FmNjE1YWJlZTQ3MWQ2ODY4MGU4MThhYSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308816831",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183299",
  "custom_google_gtm_id": "GTM-5ZRBP4K8",
  "custom_rollout_phase": "Phase 2",
  "custom_rentgrata_token": "8dcd2514-b1f0-4be7-8c2a-265731946085",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/68dc4d2a-f03e-48e6-bb3d-58b4f61efc91/app.js?property=68dc4d2a-f03e-48e6-bb3d-58b4f61efc91&propertyName=Tuscany+at+Faudree&channelUuid=c248f994-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "55405269665",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZFaENNMXNLZHcwenk2WE5wZ2g0U3c9PSIsInZhbHVlIjoianFKTFRpckhKWTdvUnRueGhYOVNwUT09IiwibWFjIjoiNWZjZTg1M2MxOGUxMTc1ODg2ZTcwMzljYjM2Yjc5MDQ0MjMzNTg3Y2FmNjE1YWJlZTQ3MWQ2ODY4MGU4MThhYSJ9",
  "custom_audioeye_site_id": "6a6d9680-f230-4146-99c9-b7a14b7d7f30",
  "custom_audioeye_site_hash": "09e3a97cc9d9b81f235e0e8e34cbc58a"
};

export const generatedAt = '2026-10-27T17:07:32.991Z';
